import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { NavigateService } from '../../service/navigate.service';
import { UserService } from '../../service/user.service';
import { EventsService } from '../../service/events.service';
import { HomeService } from "../../service/home.service";

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.styl']
})

export class ModalComponent implements OnInit{
    @Input() modal: Modal;
    @Output() onConfirm = new EventEmitter<string>();
    @Output() onSetBtn = new EventEmitter<string>();
    @Output() onCancel = new EventEmitter<string>();

    // 登录
    loginForm: FormGroup;
    login: Login = new Login('','');
    isOpenEyesShow = true;

    // 报名会议
    conferenceRegisterForm: FormGroup; // 报名会议表单
    reigsterQuestions: any = [];
    successRegister: boolean = false; //会议注册成功时候为true

    // 通用
    isSafari: boolean; // 判断是否是safari浏览器：改变password的样式
    msg: string = ''; // 错误提示信息
    validatorMsg = {
        email: {
            required: 'please input your email',
            pattern: 'please input correct email'
        },
        pwd: {
            required: 'please input your password',
            pattern: 'The password should be made up of 6-15 letters or numbers',
            minlength: 'The password should be made up of 6-15 letters or numbers',
            maxlength: 'The password should be made up of 6-15 letters or numbers'
        }
    };

    constructor(
        private formBuilder: FormBuilder,
        private navigateService: NavigateService,
        private userService: UserService,
        private eventsService: EventsService,
        private homeService: HomeService
    ){
        // 判断是否为safari浏览器
        const userAgent = navigator.userAgent;
        this.isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') < 0;
    }

    // 初始化
    ngOnInit(){
        this.buildForm();
    }

    // 构建表单
    buildForm() {
        // 登录
        if ('isSigninShow' in this.modal){
            this.loginForm = this.formBuilder.group({
                'email': [this.login.email, [
                    Validators.required,
                    Validators.pattern(/^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/)
                ]],
                'pwd': [this.login.pwd, [
                    Validators.required,
                    Validators.pattern(/^[0-9a-zA-Z]+$/),
                    Validators.minLength(6),
                    Validators.maxLength(15)
                ]]
            });
        }

        // 会议报名
        if ('isRegisterShow' in this.modal){
            this.conferenceRegisterForm = this.formBuilder.group({
                mobile: ['', Validators.required]
            });
            this.eventsService.getConferenceApplyForm(this.modal.id, 1).subscribe(res => {
                if (res.status === 200){
                    this.reigsterQuestions = res.rows || [];
                    this.reigsterQuestions.forEach((item: any) => {
                        if (item.types === 2) item.options = eval(item.options);
                        this.conferenceRegisterForm.addControl(item.id, this.formBuilder.control(''));
                    });
                }
            });
        }
    }

    // 登录
    testValid(){
        for (const field in this.login) {
            const control = this.loginForm.get(field);
            if(control && control.dirty && !control.valid) {
                for (const key in control.errors) {
                    this.showTip(this.validatorMsg[field][key]);
                }
            }
        }
    }
    onSubmit() {
        this.testValid();
        if (!this.loginForm.valid) return;
        this.msg = '';
        const { email, pwd } = this.loginForm.value;
        this.userService.login(email, pwd).subscribe(res => {
            if (res.ok){
                if (location.hash.split('/')[1] === 'register'){
                    this.navigateService.clearRouteList();
                    this.goPage('./home');
                }else{
                    // console.log('11111', 11111)
                    location.reload();
                }
            }else{
                this.showTip(res.msg);
            }
        })
    }

    // 报名会议
    onRegister() {
        let answer = [];
        Object.keys(this.conferenceRegisterForm.value).filter(key => key !== 'mobile').forEach(questionId => {
            answer.push({
                questionId: +questionId,
                question: this.reigsterQuestions.find((item: any) => item.id === +questionId)['question'],
                answer: this.conferenceRegisterForm.value[questionId],
            });
        });

        this.eventsService.applyConference({
            activityId: this.modal.id,
            telephone: this.conferenceRegisterForm.value.mobile,
            answer:JSON.stringify(answer),
        }).subscribe(res => {
            if (res.status === 200){
                this.afterSuccessRegister(); // 报名成功
            }else{
                this.showTip(res.msg || 'Registration Failed');
            }
        });
    }
    afterSuccessRegister(){
        this.confirm();
        this.setBtn(1); //已经报名会议为1;
        this.successRegister = true;
        setTimeout(() => this.successRegister = false, 2000);
    }

    // 页面跳转
    goPage(url: string){
        this.navigateService.push();
        this.navigateService.pushToRoute(url);
        this.modal.isSigninShow && (this.modal.isSigninShow = false);
    }

    confirm(){
        this.onConfirm.emit();
    }
    cancel(){
        this.onCancel.emit();
    }

    setBtn(num){
        this.onSetBtn.emit(num);
    }
    putVote(){
        console.log('putVote')
        this.homeService.putElectVote(this.modal.voteId,this.modal.sessionId).subscribe(res=>{
            console.log(res)
            res.ok && this.cancel()
        })
    }
    showTip(msg: string){
        this.msg = msg;
    }

    //检查邮箱
    checkemail(){
        this.userService.testEmail(this.loginForm.value.email,1).subscribe(res => {
            this.showTip(res.msg);
        })
    }
}

class Modal {
    constructor(
        public isSigninShow? : boolean,
        public title?: string,
        public isRegisterShow? : boolean,
        public fName? : string,
        public lName? : string,
        public email? : string,
        public school? : string,
        public id?: number,
        public isVoteShow? : boolean,
        public voteName?: string,
        public voteId? : number,
        public sessionId? : number,
    ) {}
}

class Login {
    constructor(
        public email: string,
        public pwd: string
    ){}
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/modal/modal.component.ts